import * as request from "@/utils/request";
import { DefaultConfigs } from "@/common/js/constant";
import { CouponsInfo, CouponsListInfo } from "./types";
import { TabType } from "./config";

const baseUrl = `${DefaultConfigs.publicAPIPath}`;

// 查询活动详情
// 接口文档：https://mock.xiaojukeji.com/project/24014/interface/api/1012343
export function queryVoucherList(params: {
  pageSize: number;
  currentPageNum: number;
  sofiUid: string;
  tabType: TabType;
}): Promise<CouponsListInfo> {
  return request.post<CouponsListInfo>(`${baseUrl}/sofipo/v0/voucher/queryVoucherList`, params);
}

// 查询券列表页静态信息
// 接口文档：https://mock.xiaojukeji.com/project/24014/interface/api/1017350
export function getVoucherPageInfo() {
  return request.get<CouponsInfo>(`${baseUrl}/sofipo/v0/voucher/getVoucherPageInfo`);
}
